
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import expertDefault from "../images/default.png"
import $ from "jquery"

export default class Experts extends Component {
    componentDidMount(){
      
	var acc = document.getElementsByClassName("accordion");
	var i;

	for (i = 0; i < acc.length; i++) {
	  acc[i].addEventListener("click", function() {
	    this.classList.toggle("active");
	    var panel = this.nextElementSibling;
	    if (panel.style.display === "block") {
	      panel.style.display = "none";
	    } else {
	      panel.style.display = "block";
	    }
	  });
	}
    }
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content"> 
            <section className="courses-wrapper">
            <div className='page-top-section'>
              <div className='page-top-head'>
                <h4>Experts</h4>
                <p className='breadcrumb'>
                  <a href="/">Home</a>
                  <span className='px-2'> / </span>
                  <a href="/courses">Instructors List</a>
                </p>
              </div>
            </div>
            <div className="py-0 py-md-5">
              <div className="container">
                <div className='row course-section'>
                  <div className='col-md-12 row'>
                    <div className='col-lg-3 offset-lg-7 form-group' style={{position:"relative"}}>
                      <input type="text" className="form-control" placeholder="Search Instructor..." />
                      <svg className="svg-icon search-icon" aria-hidden="true" role="img" focusable="false" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.80758 0C3.95121 0 0 3.95121 0 8.80758C0 13.6642 3.95121 17.6152 8.80758 17.6152C13.6642 17.6152 17.6152 13.6642 17.6152 8.80758C17.6152 3.95121 13.6642 0 8.80758 0ZM8.80758 15.9892C4.8477 15.9892 1.62602 12.7675 1.62602 8.80762C1.62602 4.84773 4.8477 1.62602 8.80758 1.62602C12.7675 1.62602 15.9891 4.8477 15.9891 8.80758C15.9891 12.7675 12.7675 15.9892 8.80758 15.9892Z" fill="currentColor"></path><path d="M19.762 18.6121L15.1007 13.9509C14.7831 13.6332 14.2687 13.6332 13.9511 13.9509C13.6335 14.2682 13.6335 14.7831 13.9511 15.1005L18.6124 19.7617C18.7712 19.9205 18.9791 19.9999 19.1872 19.9999C19.395 19.9999 19.6032 19.9205 19.762 19.7617C20.0796 19.4444 20.0796 18.9295 19.762 18.6121Z" fill="currentColor"></path></svg>
                    </div>
                    <div className='col-lg-2 form-group'>
                      <select className="form-control">
                        <option>Sort by: Default</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="experts-body col-lg-12">
                    <div className="experts-box">
                      <a href="/experts-details" className="experts-box-a">
                        <div className='experts-box-img'>
                          <img alt="" className="experts-img" src={expertDefault} />
                        </div>
                        <p className="experts-box-text">Anoop</p>
                        <p className="experts-box-subtext">AI Consultant|Ph.D. & M.Phil in AI</p>
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </section>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/ivano/experts.jsx